export default __webpack_public_path__ + "static/project-gwb-thumbnail-4314f071f17388ced97c501b2ff935ae.png";